import React, { Component } from 'react';

class Details extends Component {

  render() {
    return (
      <div>
        <div className="resume-details">
          <div className="personal-details">
            <div className="heading">
              Personal Details
            </div>
            <div className="details">
              <div className="title">
                Name
              </div>
              <div className="name">
                Suraj Kumar
              </div>
            </div>
            <div className="details">
              <div className="title">
                Nationality
              </div>
              <div className="name">
                Indian
              </div>
            </div>
            <div className="details">
              <div className="title">
                Birthday
              </div>
              <div className="name">
                15/12/1991
              </div>
            </div>
            <div className="details">
              <div className="title">
                Language
              </div>
              <div className="name">
                English, Hindi
              </div>
            </div>
            <div className="details">
              <div className="title">
                Current city
              </div>
              <div className="name">
                Mumbai
              </div>
            </div>
            <div className="details">
              <div className="title">
                Email
              </div>
              <div className="name">
                kumarsrj815@gmail.com
              </div>
            </div>
            <div className="details">
              <div className="title">
                Phone
              </div>
              <div className="name">
                9769404021
              </div>
            </div>
            <br></br>
            <div className="heading">
              Web Teahnologies
            </div>
            <div className="tech">
              <div>HTML/CSS</div>
              <progress value="90" max="100"></progress>
            </div>
            <div className="tech">
              <div>Javascript</div>
              <progress value="80" max="100"></progress>
            </div>
            <div className="tech">
              <div>AngularJS</div>
              <progress value="80" max="100"></progress>
            </div>
            <div className="tech">
              <div>Bootstrap</div>
              <progress value="80" max="100"></progress>
            </div>
            <div className="tech">
              <div>SASS</div>
              <progress value="80" max="100"></progress>
            </div>
            <div className="tech">
              <div>React</div>
              <progress value="50" max="100"></progress>
            </div>
            <div className="tech">
              <div>Nodejs</div>
              <progress value="50" max="100"></progress>
            </div>
            <div className="tech">
              <div>Nginx</div>
              <progress value="50" max="100"></progress>
            </div>
            <div className="tech">
              <div>Git</div>
              <progress value="70" max="100"></progress>
            </div>
            <div className="tech">
              <div>Angular4</div>
              <progress value="50" max="100"></progress>
            </div>
            <div className="heading">
              Web Design
            </div>
            <div className="tech">
              <div>Wireframe</div>
              <progress value="90" max="100"></progress>
            </div>
            <div className="tech">
              <div>Photoshop</div>
              <progress value="80" max="100"></progress>
            </div>
            <div className="tech">
              <div>Corel Draw</div>
              <progress value="60" max="100"></progress>
            </div>
            <div className="tech">
              <div>Adobe Illustrator</div>
              <progress value="60" max="100"></progress>
            </div>
            <div className="tech">
              <div>Adobe XD</div>
              <progress value="60" max="100"></progress>
            </div>
            <div className="heading">
              Others
            </div>
            <div className="others-details">
              Linux, Painting, Sketching, UI/UX Design, Graphic Design, After Effects, Adobe Fireworks, Adobe Bridge,
            </div>
          </div>
          <div className="work-details">
            <div className="heading">
              Work Details
            </div>
            <div className="work-section">

              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    March 2016 - Present
                </div>
                <div className="work-title">
                    Software Engineer - PSTakeCare , Mumbai
                </div>
                <div className="work-des">
                  Revamp and maintain PSTakeCare Website.<br></br>
                  Develop PSTakeCare International Outreach Clinic Landing Page<br></br>
                  Develop PSTakeCare Hospital Marketing Landing Page<br></br>
                  Design and Development of Internal Panel for Uploading and Updating data for Website and App.<br></br>
                  Design and develop Quotes Sending Panel for pstakecare patient care team through which they send quotes
                  to patients and connect them to hospitals spocs.<br></br>
                  Develop Drip Marketing Mailers & Campaign Mailers for mass mailing<br></br>
                  Design WhatsApp and Facebook Creative.
                </div>
              </div>

              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    1 Dec 2015 - 1 March 2016
                </div>
                <div className="work-title">
                    Internship - PSTakeCare , Mumbai
                </div>
                <div className="work-des">
                  Design wireframes of internal panel for Upload and Update data for Website and App.<br></br>
                  UI Design and Development of Internal Panel for Upload and Update data for Website and App.<br></br>
                  Develop Drip Marketing Mailers & Campaign Mailers for mass mailing<br></br>
                  Design posters, banners, Facebook post for marketing.
                </div>
              </div>

              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    1 Dec 2015 - 1 March 2016
                </div>
                <div className="work-title">
                    Internship - PSTakeCare , Mumbai
                </div>
                <div className="work-des">
                  Design wireframes of internal panel for Upload and Update data for Website and App.<br></br>
                  UI Design and Development of Internal Panel for Upload and Update data for Website and App.<br></br>
                  Develop Drip Marketing Mailers & Campaign Mailers for mass mailing<br></br>
                  Design posters, banners, Facebook post for marketing.
                </div>
              </div>

              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    1 dec 2015 - 1 march 2016
                </div>
                <div className="work-title">
                    Internship - PSTakeCare , Mumbai
                </div>
                <div className="work-des">
                  Design wireframes of internal panel for Upload and Update data for Website and App.<br></br>
                  UI Design and Development of Internal Panel for Upload and Update data for Website and App.<br></br>
                  Develop Drip Marketing Mailers & Campaign Mailers for mass mailing<br></br>
                  Design posters, banners, Facebook post for marketing.
                </div>
              </div>
              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    Before 2016
                </div>
                <div className="work-title">
                    Web design, Graphic design and coding during college
                </div>
                <div className="work-des">
                  Design wireframes of internal panel for Upload and Update data for Website and App.<br></br>
                  UI Design and Development of Internal Panel for Upload and Update data for Website and App.<br></br>
                  Develop Drip Marketing Mailers & Campaign Mailers for mass mailing<br></br>
                  Design posters, banners, Facebook post for marketing.
                </div>
              </div>

            </div>

            <div className="heading">
              Education Details
            </div>
            <div className="work-section">
              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    2011-2015
                </div>
                <div className="work-title">
                    Sambhram Institute of Technology, Bengaluru.
                </div>
                <div className="work-des">
                  Bachelor Of Engineering (ECE)
                </div>
              </div>

              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    2008-2010
                </div>
                <div className="work-title">
                    A.N College,Patna
                </div>
                <div className="work-des">
                  Intermediate
                </div>
              </div>

              <div className="dot">&#11044;</div>
              <div className="work">
                <div className="work-year">
                    2007-2008
                </div>
                <div className="work-title">
                    R.B.R High School,Rafiganj
                </div>
                <div className="work-des">
                  Matriculation
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    );
  }

}

export default Details;



// WEBPACK FOOTER //
// ./src/components/my-details/details.js